export default "__VITE_ASSET__ch0nVl89__"